import { Row as RowHouston, styled, Typography } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const Row = styled(RowHouston)`
  width: 100%;
  margin: 0;
`;

export const OfferTitle = styled(Row)`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;

export const TypographyPosition = styled(Typography)`
  color: ${({ theme }) => theme.neutralColor.low.medium};
`;
